import NavBar from './navbar';
import NavMenu from './navmenu';
import { useAppDispatch, useAppSelector } from '../slices/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import * as UI from '../slices/uiSlice';
import * as Cases from '../slices/casesSlice';
import * as Forms from '../slices/formsSlice';
import TrackerChart from './trackerchart';
import { AnyAction } from '@reduxjs/toolkit';
import TrackerPercent from './trackerpercent';
import { doFormOnChange, getFormValueWithId, getJSONWithFormValues, validateForm } from '../utilities';
import { useEffect, useState } from 'react';
import leading_the_way from '../assets/Leading_The_Way_Conveyancing.svg';
import hub_logo from '../assets/Main_Hub_Icon_Large.svg';
import LinkedCaseListItem from './linkedcaselistitem';
import { useMediaQuery } from 'react-responsive';
import OpenCaseIcon from '../assets/open-case-icon.svg';
import CaseDetailsIconBlue from '../assets/case-details-icon-blue.svg';
import ActionsIconBlue from '../assets/actions-icon-blue.svg';
import FormsAndReportsIconBlue from '../assets/forms-and-reports-icon-blue.svg';
import MeetTheTeamIconBlue from '../assets/meet-the-team-icon-blue.svg';
import WishlistIconBlue from '../assets/wishlist-icon-blue.svg';

const Case = () => {
	const uiState = useAppSelector(state => state.ui);
	const cases = useAppSelector(state => state.cases);
	const user = useAppSelector(state => state.user);
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const [trackerDataOptions, setTrackerDataOptions] = useState<{ stage: string; items: any[] }[]>([]);

	const handleMediaQueryChange = (matches: boolean) => {
	}
	const isTabletOrMobile = useMediaQuery({ maxWidth: 1024, orientation: 'portrait' }, undefined, handleMediaQueryChange);

	const handleScroll = () => {
		dispatch((UI.closeMenu()) as unknown as AnyAction);
	};

	const openCase = () => {
		navigate('/case');
	}

	const openCaseDetails = () => {
		navigate('/case-details');
	}

	const openActions = () => {
		navigate('/actions');
	}

	const openHistory = () => {
		navigate('/historylist');
	}

	const openTeam = () => {
		navigate('/team');
	}

	const wishList = () => {
		if (cases.case.details && cases.case.details.wishlisted) {
			dispatch(UI.setWishlistEditPopup({ visible: true, caseno: cases.case.caseno, casetype: cases.case.type }));
		} else {
			dispatch(UI.setWishlistPopup({ visible: true, caseno: cases.case.caseno, casetype: cases.case.type }));
		}
	}

	const updateDates = () => {
		if (validateForm('ICD', 'ICD')) {
			dispatch(Cases.setUpdatingDates(true));
			const json = getJSONWithFormValues('ICD');
			const data = JSON.parse(json);

			const state: Cases.updateCaseDatesState = {
				caseno: cases.case.caseno,
				id: user.id,
				usertype: user.type,
				token: user.token,
				casetype: cases.case.casetype,
				handler: (cases.case.details ? cases.case.details.handler : ''),
				valuation_booked: data.valuation_booked.val,
				mortgage_completed: data.mortgage_completed.val,
				valuation_completed: data.valuation_completed.val
			}
			dispatch(Cases.updateCaseDates(state) as unknown as AnyAction).then(() => {
			});
		}
	}

	useEffect(() => {
		dispatch(Forms.setFormValueWithId({
			form: 'ICD',
			type: 'text',
			id: 'valuation_booked',
			val: (cases.case.IntroducerDates.valuation_booked != null ? cases.case.IntroducerDates.valuation_booked : '')
		}));
		dispatch(Forms.setFormValueWithId({
			form: 'ICD',
			type: 'text',
			id: 'mortgage_completed',
			val: (cases.case.IntroducerDates.mortgage_completed != null ? cases.case.IntroducerDates.mortgage_completed : '')
		}));
		dispatch(Forms.setFormValueWithId({
			form: 'ICD',
			type: 'text',
			id: 'valuation_completed',
			val: (cases.case.IntroducerDates.valuation_completed != null ? cases.case.IntroducerDates.valuation_completed : '')
		}));

		const groupedTrackerData: { [key: string]: { stage: string, items: any[] } } = {};
		if (cases.case.details?.tracker) {
			cases.case.details.tracker.forEach(item => {
				if (!groupedTrackerData[item.stage]) {
					groupedTrackerData[item.stage] = { stage: item.stage, items: [] };
				}
				groupedTrackerData[item.stage].items.push({ ...item, isVisible: true });
			});

			const updatedTrackerDataOptions = Object.values(groupedTrackerData);
			setTrackerDataOptions(updatedTrackerDataOptions);
		}
	}, [cases.case.IntroducerDates, dispatch]);

	useEffect(() => {
		if (!cases.case.caseno) {
			navigate('/hub');
		}
	}, [])

	return (
		<div className="Home" style={{ position: 'relative' }}>
			<div style={{ position: 'absolute', top: 96, left: 0, right: 0, bottom: 80, overflow: 'hidden auto' }}>
				<div className='OrangeBand'>
					<div style={{ marginLeft: 'calc(10% + 144px)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', overflow: 'hidden' }}>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<img style={{ width: 96, marginRight: 8 }} src={hub_logo} alt='Hub-Logo' />
							<div style={{ marginLeft: 24 }}>
								<div style={{ fontFamily: 'OpenSans-Bold', fontSize: 36, marginBottom: 12, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{(isTabletOrMobile ? 'Reference' : 'Client Reference Number')} - {cases.case.caseno}</div>
							</div>
						</div>
					</div>
				</div>
				<div className="row100 topButtonContainer" style={{ justifyContent: 'start', alignItems: 'end', position: 'absolute', top: '150px', left: '2%', zIndex: 995 }}>
					<div className='buttonPurple' style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', overflow: 'hidden' }} onClick={() => openCase()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '40px' }}>
							<img className='topButtonImage' style={{ width: 20, height: 20, marginRight: 8 }} src={OpenCaseIcon} alt='Milestones-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Milestones</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningActions &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className='buttonPurpleSecondary' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openCaseDetails()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '45px' }}>
							<img className='topButtonImage' style={{ width: 20, height: 20, marginRight: 8 }} src={CaseDetailsIconBlue} alt='CaseDetails-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Case Details</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningActions &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className='buttonPurpleSecondary' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openActions()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '40px' }}>
							<img className='topButtonImage' style={{ width: 20, height: 20, marginRight: 8 }} src={ActionsIconBlue} alt='Actions-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Actions</div>
							{cases.case.details && cases.case.details.unviewActions.length > 0 && <div style={{ height: '19px', width: '19px', marginLeft: '10px', backgroundColor: 'red', borderRadius: '50%', color: '#FFFFFF', fontSize: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{cases.case.details.unviewActions.length}</div>}
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningActions &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className='buttonPurpleSecondary' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openHistory()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '50px' }}>
							<img className='topButtonImage' style={{ width: 20, height: 20, marginRight: 8 }} src={FormsAndReportsIconBlue} alt='Forms&Reports-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Forms & Reports</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningActions &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className='buttonPurpleSecondary' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openTeam()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '50px' }}>
							<img className='topButtonImage' style={{ width: 20, height: 20, marginRight: 8 }} src={MeetTheTeamIconBlue} alt='Team-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Meet the Team</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningTeam &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className={(cases.case.details?.wishlisted ? 'buttonGreenRounded' : 'buttonPurpleSecondary')} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => wishList()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '40px' }}>
							<img className='topButtonImage' style={{ width: 20, height: 20, marginRight: 8 }} src={WishlistIconBlue} alt='Wishlist-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Wishlist{(cases.case.details?.wishlisted ? ' - ' + cases.case.details.wishlisted : '')}</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isWishlisting &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
				</div>
				<div className='datesContainer' style={{ justifyContent: 'start', alignItems: 'end', position: 'absolute', zIndex: 997, top: 215, width: 220, left: '2%' }}>
					{cases.case.type !== 'S' &&
						<div id='ICD' style={{ width: 220 }}>
							<div style={{ fontFamily: 'OpenSans-Bold', fontSize: 16, color: 'black', marginBottom: 8 }}>Introducer Dates</div>
							<div style={{ fontFamily: 'OpenSans-Regular', fontSize: 14, color: 'black', marginBottom: 4 }}>Mortgage Application Completed:</div>
							<input type='date' data-form-id={'ICD'} value={getFormValueWithId('ICD', "mortgage_completed")} name='mortgage_completed' id='mortgage_completed' onChange={(e) => doFormOnChange(e)} />
							<div style={{ fontFamily: 'OpenSans-Regular', fontSize: 14, color: 'black', marginBottom: 4, marginTop: 8 }}>Valuation Booked:</div>
							<input type='date' data-form-id={'ICD'} value={getFormValueWithId('ICD', "valuation_booked")} name='valuation_booked' id='valuation_booked' onChange={(e) => doFormOnChange(e)} />
							<div style={{ fontFamily: 'OpenSans-Regular', fontSize: 14, color: 'black', marginBottom: 4, marginTop: 8 }}>Valuation Completed:</div>
							<input type='date' data-form-id={'ICD'} value={getFormValueWithId('ICD', "valuation_completed")} name='valuation_completed' id='valuation_completed' onChange={(e) => doFormOnChange(e)} />
							<div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: 8 }}>
								<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => updateDates()}>
									<div style={{ display: 'flex' }}>
										<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', marginLeft: 24 }}>Update</div>
									</div>
									<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
										{cases.isUpdatingDates &&
											<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
										}
									</div>
								</div>
							</div>
						</div>
					}
					{cases.case.type === 'S' &&
						<div style={{ width: 242 }}></div>
					}
				</div>
				<div className='trackerPercentContainer'>
					<TrackerPercent data={cases.case} size={128} />
				</div>
				{cases.case.details && cases.case.details.linked.length > 0 && isTabletOrMobile &&
					<div className='linkedCases' style={{ position: 'absolute', zIndex: 997, left: 30, width: 380 }}>
						<div style={{ fontFamily: 'OpenSans-Bold', color: 'black' }}>Linked Cases:</div>
						<div className="row100">
							<div className="flexGrow1 TabHeaderLeft" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }}>
								<div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>
									<div>Reference</div>
								</div>
							</div>
							<div className="flexGrow1 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }}>
								<div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>
									<div>Type</div>
								</div>
							</div>
							<div className="flexGrow2 TabHeaderRight" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }}>
								<div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>
									<div>Address</div>
								</div>
							</div>
						</div>
						<div>
							{(cases.case.details.linked || []).map((item: Cases.caseListState) => (
								<LinkedCaseListItem key={item.caseno} {...item} />
							))}
						</div>
					</div>
				}
				{cases.case.details && cases.case.details.linked.length > 0 && !isTabletOrMobile &&
					<div className='linkedCases' style={{ position: 'absolute', zIndex: 999, top: (cases.case.type === 'S' ? 400 : ''), left: '2%', width: 380 }}>
						<div style={{ fontFamily: 'OpenSans-Bold', color: 'black' }}>Linked Cases:</div>
						<div className="row100">
							<div className="flexGrow1 TabHeaderLeft" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }}>
								<div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>
									<div>Reference</div>
								</div>
							</div>
							<div className="flexGrow1 TabHeaderCenter" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }}>
								<div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>
									<div>Type</div>
								</div>
							</div>
							<div className="flexGrow2 TabHeaderRight" style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden', textOverflow: 'ellipsis' }}>
								<div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 8, marginRight: 8, width: '100%', alignItems: 'center' }}>
									<div>Address</div>
								</div>
							</div>
						</div>
						<div>
							{(cases.case.details.linked || []).map((item: Cases.caseListState) => (
								<LinkedCaseListItem key={item.caseno} {...item} />
							))}
						</div>
					</div>
				}
				<div className={`trackerChartContainer ${cases.case.details && cases.case.details.linked.length > 0 ? 'linkedCasesChart' : ''}`} onScroll={handleScroll}>
					{isTabletOrMobile &&
						<div className="flexGrow2" style={{ textOverflow: 'ellipsis' }}>
							<TrackerChart data={cases.case} size={468} />
						</div>
					}
					{!isTabletOrMobile &&
						<div className="flexGrow2 trackerChartContainerDesktop" style={{ textOverflow: 'ellipsis', position: 'relative' }}>
							<TrackerChart data={cases.case} size={500} />
						</div>
					}
				</div>
			</div>

			<div className='mainFooter'>
				<div style={{ marginLeft: '10%', marginRight: '10%', width: '80%', marginTop: 18 }}>
					<img style={{ height: 28 }} src={leading_the_way} alt='LeadingTheWay-Banner' />
				</div>
			</div>
			<div className='loginFooter'></div>
			<NavMenu />
			<NavBar />
		</div>
	);
}

export default Case;